__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-to-be-reimbursed/').replace(/[/]{3,}/g, "/");